import type * as Types from 'app/types/graphql';

import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type ShopUpdateThemeExtensionMutationVariables = Types.Exact<{
  extensionType: Types.Scalars['String']['input'];
  disable: Types.Scalars['Boolean']['input'];
  appType: Types.AppType;
}>;

export type ShopUpdateThemeExtensionMutationResponse = Pick<
  Types.Mutation,
  'shopUpdateThemeExtension'
>;

export const ShopUpdateThemeExtensionDocument = `
    mutation ShopUpdateThemeExtension($extensionType: String!, $disable: Boolean!, $appType: AppType!) {
  shopUpdateThemeExtension(
    extensionType: $extensionType
    disable: $disable
    appType: $appType
  )
}
    `;

export const useShopUpdateThemeExtensionMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    ShopUpdateThemeExtensionMutationResponse,
    TError,
    ShopUpdateThemeExtensionMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    ShopUpdateThemeExtensionMutationResponse,
    TError,
    ShopUpdateThemeExtensionMutationVariables,
    TContext
  >(
    ['ShopUpdateThemeExtension'],
    (variables?: ShopUpdateThemeExtensionMutationVariables) =>
      appFetcher<
        ShopUpdateThemeExtensionMutationResponse,
        ShopUpdateThemeExtensionMutationVariables
      >(ShopUpdateThemeExtensionDocument, variables)(),
    options,
  );
};

useShopUpdateThemeExtensionMutation.getKey = () => ['ShopUpdateThemeExtension'];
